(function () {
  function init(root) {
    const tabs = Array.from(root.querySelectorAll('[data-hf-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-hf-panel]'));
    if (!tabs.length || !panels.length) return;

    function setActive(id) {
      tabs.forEach((t) => {
        const active = t.getAttribute('data-hf-tab') === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((p) => {
        const active = p.getAttribute('data-hf-panel') === id;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    tabs.forEach((t) => t.addEventListener('click', () => setActive(t.getAttribute('data-hf-tab'))));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hf-ptabs]').forEach(init);
  });
})();